import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideNgxMask } from 'ngx-mask';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './util/loading.interceptor';
import { AgGridModule } from 'ag-grid-angular';
import { authGuard } from './auth/auth.guard';
import { BrowserModule } from '@angular/platform-browser';
import { apiKeyInterceptor } from './service/interceptors/auth.api-key.interceptor';
import { UtilityService } from './service/utility.service';

const startPortalConfigurationLoad = (utilityService: UtilityService) => () => {
  utilityService.ensurePortalConfigurationRequested();
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([apiKeyInterceptor])), // Register both interceptors
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      closeButton: true,
    }),
    provideNgxMask({
      validation: true,
      dropSpecialCharacters: false,
    }),
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: startPortalConfigurationLoad,
      deps: [UtilityService],
      multi: true,
    },
    AgGridModule,
    authGuard,
    BrowserModule,
  ],
};
